type Environment = {
    identifier: string,
    env: string,
    domainName: string,
    mirror?: string
}

export function detectEnv(): Environment {
    switch (window.location.hostname) {
        case 'beachpro.fr':
        case 'www.beachpro.fr':
        case 'beachcomber-prod.facilitatrip.com': return {
            identifier: 'beachcomber',
            env: 'production',
            domainName: 'beachcomber.facilitatrip.com'
        };
        case 'beachcomber-cms.facilitatrip.com': return {
            identifier: 'beachcomber',
            env: 'staging',
            domainName: 'beachcomber.facilitatrip.fr'
        };
        case 'capamerique.com':
        case 'www.capamerique.com':
        case 'visiteurs-prod.facilitatrip.com': return {
            identifier: 'visiteurs',
            env: 'production',
            domainName: 'visiteurs.facilitatrip.com'
        };
        case 'online.touristforum.net': return {
            identifier: 'tourist-forum',
            env: 'production',
            domainName: 'tourist-forum.facilitatrip.com'
        };
        case 'cms-btc.facilitatrip.com':
        case 'cms.facilitatrip.com': return {
            identifier: 'dev',
            env: 'development',
            domainName: 'dev.facilitatrip.com'
        }
        case 'climatsdumonde-cms.facilitatrip.com': return {
            identifier: 'climatsdumonde',
            env: 'staging',
            domainName: 'climatsdumonde.facilitatrip.fr'
        };
        case 'localhost': return {
            identifier: 'dev',
            env: 'development',
            domainName: 'dev.facilitatrip.com'
        }
    }

    let domain_name = window.location.host.replace("www.", "").replace("-prod", "");
    const isBonogo = domain_name.includes("capamerique");
    domain_name = domain_name.replace("capamerique", "visiteurs");
    const customer_identifier = domain_name.split('.')[0];
    const domainNameParts = domain_name.split('.');

    let env = 'development';

    if (
        domainNameParts[domainNameParts.length - 1] === 'fr' &&
            window.location.hostname !== 'test-aws.facilitatrip.fr'
    ) {
        env = 'staging';
    } else if (domainNameParts[domainNameParts.length - 1] === 'com') {
        env = 'production';
    }

    return {
        identifier: customer_identifier ?? '',
        env,
        domainName: domain_name,
        mirror: isBonogo ? 'bonogo' : undefined
    };
}